var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "white",
    strokeOpacity: 0.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3334 23.4917C28.3334 26.5251 26.525 28.3334 23.4917 28.3334H22.5C22.0417 28.3334 21.6667 27.9584 21.6667 27.5001V22.6918C21.6667 22.4668 21.85 22.2751 22.075 22.2751L23.5417 22.2501C23.6584 22.2418 23.7584 22.1584 23.7834 22.0418L24.075 20.4501C24.1 20.3001 23.9834 20.1584 23.825 20.1584L22.05 20.1834C21.8167 20.1834 21.6334 20.0001 21.625 19.7751L21.5917 17.7334C21.5917 17.6001 21.7 17.4834 21.8417 17.4834L23.8417 17.4501C23.9833 17.4501 24.0917 17.3418 24.0917 17.2001L24.0583 15.2001C24.0583 15.0584 23.95 14.9501 23.8084 14.9501L21.5583 14.9834C20.175 15.0084 19.075 16.1417 19.1 17.5251L19.1417 19.8167C19.15 20.0501 18.9667 20.2334 18.7334 20.2418L17.7334 20.2584C17.5917 20.2584 17.4834 20.3667 17.4834 20.5084L17.5084 22.0918C17.5084 22.2334 17.6167 22.3417 17.7584 22.3417L18.7584 22.3251C18.9917 22.3251 19.175 22.5084 19.1833 22.7334L19.2583 27.4834C19.2667 27.9501 18.8917 28.3334 18.425 28.3334H16.5084C13.475 28.3334 11.6667 26.5251 11.6667 23.4834V16.5084C11.6667 13.4751 13.475 11.6667 16.5084 11.6667H23.4917C26.525 11.6667 28.3334 13.4751 28.3334 16.5084V23.4917Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.7a8d05d5f5567805ac2f8313d81323fa.svg";
export { ForwardRef as ReactComponent };